import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'arrayJoin'
})
export class ArrayJoinPipe implements PipeTransform {
  transform(input:Array<any>, sep = ','): string {
    if (Array.isArray(input)) {
      return input.join(sep);
    } else {
      return input;
    }
  }
}